import { render, staticRenderFns } from "./AddSliderForm.vue?vue&type=template&id=a3463b32&scoped=true&"
import script from "./AddSliderForm.vue?vue&type=script&lang=js&"
export * from "./AddSliderForm.vue?vue&type=script&lang=js&"
import style0 from "./AddSliderForm.vue?vue&type=style&index=0&id=a3463b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3463b32",
  null
  
)

export default component.exports